import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { JobService } from '../../../services/job/job.service';
import { CommonModule } from '@angular/common';
import { SocialMediaAccount } from '../../../models/socialMediaAccount';
import { CompanyInfo } from '../../../models/companyInfo';
import { FirestoreService } from '../../../services/firestore/firestore.service';
import { SharedService } from '../../../services/shared/shared.service';

@Component({
  selector: 'app-footer',
  imports: [RouterLink,CommonModule],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.css'
})
export class FooterComponent {
  categories: string[] = [];

  socialMediaAccounts: SocialMediaAccount[] = [];
    companyInfo: CompanyInfo | null = null;

  constructor(
    private jobService: JobService,
    private firestoreService: FirestoreService,
    public sharedService:SharedService


  ){

  }

  ngOnInit(){
    this.getJobCategories();
    this.loadCompanyInfo();
    this.loadSocialMediaAccounts();
  }
getJobCategories(): void {
    this.jobService.getAllCategories().subscribe(cats => {
      this.categories = cats;
    });
  }


  loadSocialMediaAccounts() {
    this.firestoreService.getAll('socialMedia').subscribe({
      next: (accounts) => {
        this.socialMediaAccounts = accounts;
        
      },
     
    });
  }

  loadCompanyInfo() {
   this.firestoreService.getById('companyInfo', 'main').subscribe({
      next: (info) => {
        this.companyInfo = info || null;
    
      },
     
    });
  }

}
